import { ProfileComponent } from './profile/profile.component';
import { HomeComponent } from './home/home.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { NotfoundComponent } from './notfound/notfound.component';
import { RegisterComponent } from './register/register.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { AdminComponent } from './adminPage/admin/admin.component';
import { DocumentationComponent } from './documentation/documentation.component';
import { SettingsComponent } from './settings/settings.component';
import { AuthGuardService } from './serv/auth-guard.service';
import { AdminAuthGuardService } from './serv/admin-auth-guard.service';
import { ShowContactComponent } from './adminPage/contacts/show-contact/show-contact.component';
import { DashboardComponent } from './adminPage/dashboard/dashboard.component';




const routes: Routes = [
  { path:'' ,component:HomeComponent},

  // public page
  { path:'login',component: LoginComponent},
  { path:'register',component: RegisterComponent},
  { path:'forgotPassword',component: ForgotPasswordComponent},

  // if login page
  { path:'profile',component: ProfileComponent ,canActivate: [AuthGuardService]},
  { path:'documentation',component: DocumentationComponent ,canActivate: [AuthGuardService]},
  { path:'settings',component: SettingsComponent,canActivate: [AuthGuardService] },

  // admin page,
  { path:'adminPage/admin',component: AdminComponent,canActivate: [AuthGuardService,AdminAuthGuardService],children :[
    
    { path:'',component:DashboardComponent},
    { path:'contacts/showContact',component: ShowContactComponent}
  ]},
  


  // any path error
  { path:'**',component:NotfoundComponent}

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
